import { parseSource } from 'env/utils/babelHelpers';
import { inject } from 'mobx-react';
import { useState, useEffect } from 'react';

const NodeCache = require('node-cache');
const cache = new NodeCache({ stdTTL: 60 * 60 * 24 });

// Handles circular references during JSON serialization
const replacerFunc = () => {
  const visited = new WeakSet();
  return (key, value) => {
    if (typeof value === 'object' && value !== null) {
      if (visited.has(value)) {
        return;
      }
      visited.add(value);
    }
    return value;
  };
};

const LoadableComponent = inject('appStore')(
  ({ url, appStore, loadingComponent, depth = 0, ...rest }) => {
    const [Component, setComponent] = useState(null);

    if (depth > 10) throw Error('Custom component depth too deep (max = 10)');

    useEffect(() => {
      const loadCustomComponent = async () => {
        console.log('loadCustomComponent');
        // Find custom component/page
        const relativeUrl = url
          .toLowerCase()
          .split('/page/')[1]
          .split('.jsx')[0];
        const foundPage = appStore.customPages.find((p) => {
          const thisPageUrl = `${p.Name.toLowerCase().split('.jsx')[0]}`;
          return relativeUrl == thisPageUrl;
        });

        const parse = async (source, key, url) => {
          console.log(`Parsing ${url}. Name: ${foundPage.Name}. Key: ${key}.`);
          return await parseSource(source, depth + 1);
        };

        const source = foundPage?.source;

        if (source) {
          const key = `${foundPage.Id}${foundPage.UpdatedOn}${depth}`;
          try {
            //Get component from cache or parse
            const cached = cache.get(key);
            const WrappedComponent = cached ?? (await parse(source, key, url));

            // Cache component for easier reuse
            if (cached == undefined) cache.set(key, WrappedComponent);

            setComponent(() => WrappedComponent);
          } catch (ex) {
            const errorComponent = () => (
              <div
                style={{ fontFamily: 'monospace', padding: 5, color: 'red' }}
              >{`Error parsing ${url}: ${ex}`}</div>
            );
            cache.set(key, errorComponent);
            setComponent(() => errorComponent);
          }
        } else {
          const errorComponent = () => (
            <div
              style={{ fontFamily: 'monospace', padding: 5, color: 'red' }}
            >{`Could not find component with path ${relativeUrl}`}</div>
          );
          cache.set(key, errorComponent);
          setComponent(() => errorComponent);
        }
      };
      loadCustomComponent();
    }, [url, JSON.stringify(rest, replacerFunc)]);

    if (!Component) return <></>;
    return <Component {...rest} />;
  }
);

export default LoadableComponent;
